import { SxProps, Theme } from '@mui/material/styles'

/** Valores antigos, ainda usados pelo rodape do site (Fase 4 do plano CORRETTO). */
export enum LogoTypeEnum {
  DARK = 'dark',
  LIGHT = 'light'
}

export type LogoLayout = 'horizontal' | 'vertical' | 'simbolo'

/**
 * - `cor`: azul e verde, para fundo claro.
 * - `negativo`: branco com o check verde, para fundo azul ou escuro.
 * - `branco` / `preto`: uma cor so (marca d'agua, impressao).
 */
export type LogoTone = 'cor' | 'branco' | 'negativo' | 'preto'

export interface LogoInterface {
  type?: LogoTypeEnum.DARK | LogoTypeEnum.LIGHT
  layout?: LogoLayout
  tone?: LogoTone
  /** Altura do logo; a largura acompanha a proporcao do arquivo. */
  height?: number | string | Record<string, number | string>
  alt?: string
  rauter?: () => void
  sx?: SxProps<Theme>
}
